'use strict';

import modelBlockTemplate from './modelBlock.html';

export const modelBlockDirName = 'modelBlock';
export function modelBlockDir() {
  return {
    restrict: 'E', 
    template: modelBlockTemplate,
    scope: {
      model: '='
    }
  }
}



// WEBPACK FOOTER //
// ./~/site_core/src/components/modelBlock/modelBlock.js